// extracted by mini-css-extract-plugin
export default {"additionalLanguagesTitles":"language_additionalLanguagesTitles__RDTu0","aiSubtitles":"language_aiSubtitles__V+ftV","aiSubtitlesDelayInfo":"language_aiSubtitlesDelayInfo__ft69K"};